// Created in order to avoid error importing this component directly on cofee script
import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import Button from 'zignal-landscape/lib/Button';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import InformationIcon from 'zignal-landscape/lib/Icon/InformationIcon';


const PrettyPrint = (props) => {
  const {onClick, styles}  = props;
  return (<span>
    <Button onClick={onClick}>Pretty Print</Button>
    <span className={styles.icon}>
      <ToolTip tooltipText="Press this button to automatically reformat the FFB query into a more readable layout">
        <InformationIcon />
      </ToolTip>
    </span>
  </span>);
};

PrettyPrint.propTypes = {
  onClick: PropTypes.func,
  styles: PropTypes.object.isRequired
};

export default themeable(PrettyPrint);
